import { render, staticRenderFns } from "./UserRoleTree.vue?vue&type=template&id=5814a187&scoped=true&"
import script from "./UserRoleTree.vue?vue&type=script&lang=js&"
export * from "./UserRoleTree.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleTree.vue?vue&type=style&index=0&id=5814a187&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5814a187",
  null
  
)

export default component.exports